import { useTranslation } from 'react-i18next';
import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import LogoutIcon from '@mui/icons-material/Logout';
import { useDispatch } from '@cbridge-utils/react-redux';
import { AuthAction } from '@cbridge-packages/auth';

const StyledButton = styled(Button)({
  textTransform: 'capitalize',
  fontWeight: 'normal',
  filter: 'opacity(0.9)',
  transition: 'filter 0.2s ease-in',
  '&:hover': {
    filter: 'opacity(1)',
  },
});

function SignOutButton(props: ButtonProps) {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const handleSignOut = () => {
    dispatch(AuthAction.logout());
  };

  return (
    <StyledButton
      color={'secondary'}
      size={'small'}
      disableElevation={true}
      onClick={handleSignOut}
      startIcon={<LogoutIcon />}
      {...props}
    >
      {t('text:common.button.signOut')}
    </StyledButton>
  );
}

export { SignOutButton };
